import React from 'react';

interface ChartIndexProps {
  labelA?: string;
  labelB?: string;
  colorA?: string;
  colorB?: string;
}

export const ChartIndex = ({
  labelA, labelB, colorA, colorB,
}: ChartIndexProps) => (
  <div className='mr-[9px] flex justify-end items-center' data-testid='chart-index'>
    <div className={`mr-[9px] w-[8px] h-[8px] rounded-full ${colorA || 'bg-action02'}`} />
    <div className='mr-[9px] text-[11px] font-metricMedium'>{labelA || 'Income'}</div>
    <div className={`mr-[9px] w-[8px] h-[8px] rounded-full ${colorB || 'bg-action03'}`} />
    <div className='text-[11px] font-metricMedium'>{labelB || 'Expense'}</div>
  </div>
);
